import React, { useEffect, useState } from 'react';
import { View, Text, TouchableOpacity, StyleSheet, ScrollView, useWindowDimensions } from 'react-native';
import AntDesign from '@expo/vector-icons/AntDesign';
import { navigate } from '../../../../navigation/RootNavigation';
import { TenantService } from '../../redux/tenant.service';
import FloPurchaseModal from './modals/FloPurchaseModal';
import OpenFloTerms from './modals/openfloeTerms';
import { useDispatch } from 'react-redux';
import { tenantActions } from '../../redux/tenant.actions';

const BRAND = {
  primary: '#6D08C0',
  primaryDeep: '#4E0D91',
  secondary: '#365FF2',
  text: '#1F2937',
  muted: '#667085',
  border: '#E8D9FF',
  card: '#FFFFFF',
  bg: '#F8F7FD',
};

const INFO_POINTS = [
  'Real-time tenant onboarding and communication in one place.',
  'Built-in checks for ID, Right to Rent, AML and fraud screening.',
  'Simple compliance sharing for EPC, gas certs and required documents.',
];

const Welcome = () => {
  const { width } = useWindowDimensions();
  const [count, setCount] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showModal2, setShowModal2] = useState(false);
  const dispatch = useDispatch();

  const isSmallScreen = width < 480;
  const isTablet = width >= 480 && width < 960;
  const isLargeScreen = width >= 960;

  useEffect(() => {
    FetchCounts();
  }, []);

  const FetchCounts = () => {
    TenantService.getCount().then((response) => {
      if (response?.data?.data) {
        setCount(convertDataToArray(response.data.data));
      }
    });
    dispatch(tenantActions.getFlowPackages());
  };

  function convertDataToArray(data) {
    const colorMap = {
      total_flows: 'primary',
      used_flows: 'warning',
      remaining_flows: 'success',
    };

    const iconMap = {
      total_flows: 'database',
      used_flows: 'checksquareo',
      remaining_flows: 'clockcircleo',
    };

    const formatTitle = (key) =>
      key
        .split('_')
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');

    return Object.entries(data).map(([key, value]) => ({
      title: formatTitle(key),
      count: Number(value),
      color: colorMap[key] || 'default',
      icon: iconMap[key] || 'questioncircleo',
      description:
        key === 'total_flows'
          ? 'Purchased package capacity'
          : key === 'used_flows'
            ? 'Already assigned to active work'
            : 'Ready for your next onboarding',
    }));
  }

  return (
    <ScrollView
      style={styles.page}
      contentContainerStyle={[styles.scrollContainer, isSmallScreen && styles.scrollContainerMobile]}
      showsVerticalScrollIndicator={false}
    >
      <View style={styles.container}>
        <View style={[styles.statsContainer, isSmallScreen && styles.statsContainerMobile]}>
          {count.map((item, index) => (
            <StatCard
              key={index}
              label={item.title == 'Total Flows' ? 'Total Flows Purchased' : item.title}
              value={item.count}
              color={item.color}
              icon={item.icon}
              description={item.description}
              width={isSmallScreen ? '100%' : isTablet ? '48.5%' : '32%'}
            />
          ))}
        </View>

        <FloPurchaseModal
          visible={showModal}
          onClose={(data) => {
            setShowModal(false);
            if (data) FetchCounts();
          }}
        />
        <OpenFloTerms isVisible={showModal2} onClose={() => setShowModal2(false)} />

        <View style={[styles.welcomeContainer, isLargeScreen && styles.welcomeContainerDesktop]}>
          <View style={[styles.heroCard, isLargeScreen && styles.heroCardDesktop]}>
            <View style={styles.heroBadge}>
              <AntDesign name="rocket1" size={14} color={BRAND.primary} />
              <Text style={styles.heroBadgeText}>Tenant onboarding dashboard</Text>
            </View>
            <Text style={styles.welcomeTitle}>Welcome to tlyfePro</Text>
            <Text style={styles.heroLead}>
              A smoother, branded workspace to launch new flows, track usage, and keep every tenancy task moving.
            </Text>

            <View style={styles.infoList}>
              {INFO_POINTS.map((item, index) => (
                <View key={index} style={styles.infoRow}>
                  <View style={styles.infoDot}>
                    <AntDesign name="check" size={11} color="#FFFFFF" />
                  </View>
                  <Text style={styles.infoText}>{item}</Text>
                </View>
              ))}
            </View>
          </View>

          <View style={[styles.contentCard, isLargeScreen && styles.contentCardDesktop]}>
            <Text style={styles.sectionEyebrow}>About the platform</Text>
            <Text style={styles.welcomeText}>
              tlyfePro is an industry-leading tenant onboarding solution powered by OpenBrix.
            </Text>
            <Text style={styles.welcomeText}>
              It helps you onboard tenants and interact in real time with tlyfe, the UK&apos;s popular tenant lifecycle
              app.
            </Text>
            <Text style={styles.welcomeText}>
              You can verify ID, confirm Right to Rent, and receive comprehensive references including AML and fraud
              checks, backed by a Rental Warranty.
            </Text>
            <Text style={styles.welcomeText}>
              Compliance stays simple too, with easy sharing of key documents like the How to Rent Guide, EPC, Gas
              Cert and Prescribed Information.
            </Text>

            <View style={[styles.buttonGroup, isSmallScreen && styles.buttonGroupMobile]}>
              <Button
                onPress={() => setShowModal(true)}
                label="BUY MORE"
                variant="primary"
                icon="shoppingcart"
                fullWidth={isSmallScreen}
              />
              <Button
                onPress={() => navigate('Setting')}
                label="SETTINGS"
                variant="secondary"
                icon="setting"
                fullWidth={isSmallScreen}
              />
              <Button
                onPress={() => navigate('addproperty')}
                label="START NEW FLO"
                variant="success"
                icon="plus"
                fullWidth={isSmallScreen}
              />
              <Button
                onPress={() => setShowModal2(true)}
                label="TERMS & CONDITIONS"
                variant="light"
                fullWidth={isSmallScreen}
              />
            </View>
          </View>
        </View>
      </View>
    </ScrollView>
  );
};

const StatCard = ({ label, value, color, icon, width, description }) => {
  const colorStyles = {
    primary: {
      bg: '#F3F0FF',
      border: '#DAC8FF',
      text: '#365FF2',
      accent: '#6D08C0',
      iconBg: '#E8DEFF',
    },
    warning: {
      bg: '#FFF6DB',
      border: '#F8E2A0',
      text: '#C76B00',
      accent: '#F59E0B',
      iconBg: '#FFF0C2',
    },
    success: {
      bg: '#E9FBF3',
      border: '#BFEACF',
      text: '#0C7A53',
      accent: '#18A56F',
      iconBg: '#D7F7E8',
    },
    default: {
      bg: '#F4F4F5',
      border: '#E4E4E7',
      text: '#4B5563',
      accent: '#6B7280',
      iconBg: '#FFFFFF',
    },
  };

  const currentColor = colorStyles[color] || colorStyles.default;

  return (
    <View
      style={[
        styles.statCard,
        {
          backgroundColor: currentColor.bg,
          borderColor: currentColor.border,
          width: width || '100%',
        },
      ]}
    >
      <View style={[styles.statIconWrap, { backgroundColor: currentColor.iconBg }]}>
        <AntDesign name={icon} size={18} color={currentColor.accent} />
      </View>
      <Text style={[styles.statLabel, { color: currentColor.text }]}>{label}</Text>
      <Text style={[styles.statValue, { color: currentColor.accent }]}>{value}</Text>
      <Text style={styles.statDescription}>{description}</Text>
    </View>
  );
};

const Button = ({ label, variant = 'primary', icon, onPress, fullWidth = false }) => {
  const variantStyles = {
    primary: {
      bg: BRAND.primary,
      text: '#FFFFFF',
      icon: '#FFFFFF',
      border: BRAND.primary,
    },
    secondary: {
      bg: BRAND.secondary,
      text: '#FFFFFF',
      icon: '#FFFFFF',
      border: BRAND.secondary,
    },
    success: {
      bg: '#0FA968',
      text: '#FFFFFF',
      icon: '#FFFFFF',
      border: '#0FA968',
    },
    light: {
      bg: '#F8F5FF',
      text: BRAND.primaryDeep,
      icon: BRAND.primaryDeep,
      border: BRAND.border,
    },
  };

  const currentVariant = variantStyles[variant] || variantStyles.primary;

  return (
    <TouchableOpacity
      onPress={onPress}
      style={[
        styles.button,
        {
          backgroundColor: currentVariant.bg,
          borderColor: currentVariant.border,
          width: fullWidth ? '100%' : '48.5%',
        },
      ]}
      activeOpacity={0.86}
    >
      <View style={styles.buttonContent}>
        {icon ? <AntDesign name={icon} size={16} color={currentVariant.icon} style={styles.buttonIcon} /> : null}
        <Text style={[styles.buttonText, { color: currentVariant.text }]}>{label}</Text>
      </View>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  page: {
    backgroundColor: BRAND.bg,
  },
  scrollContainer: {
    flexGrow: 1,
    paddingTop: 6,
    paddingBottom: 32,
  },
  scrollContainerMobile: {
    paddingBottom: 24,
  },
  container: {
    paddingHorizontal: 16,
  },
  statsContainer: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    marginBottom: 18,
  },
  statsContainerMobile: {
    flexDirection: 'column',
  },
  statCard: {
    minHeight: 96,
    paddingHorizontal: 14,
    paddingVertical: 12,
    borderRadius: 18,
    borderWidth: 1,
    marginBottom: 8,
    shadowColor: '#351063',
    shadowOffset: { width: 0, height: 6 },
    shadowOpacity: 0.05,
    shadowRadius: 12,
    elevation: 1,
  },
  statIconWrap: {
    width: 32,
    height: 32,
    borderRadius: 10,
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 8,
  },
  statLabel: {
    fontSize: 10,
    fontWeight: '700',
    textTransform: 'uppercase',
    letterSpacing: 0.8,
    marginBottom: 4,
  },
  statValue: {
    fontSize: 21,
    fontWeight: '800',
    marginBottom: 1,
  },
  statDescription: {
    fontSize: 10,
    lineHeight: 14,
    color: BRAND.muted,
  },
  welcomeContainer: {
    marginTop: 4,
  },
  welcomeContainerDesktop: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  heroCard: {
    backgroundColor: '#F5EEFF',
    borderRadius: 28,
    padding: 22,
    borderWidth: 1,
    borderColor: BRAND.border,
    marginBottom: 16,
    shadowColor: '#6D08C0',
    shadowOffset: { width: 0, height: 12 },
    shadowOpacity: 0.08,
    shadowRadius: 22,
    elevation: 4,
  },
  heroCardDesktop: {
    width: '36%',
    marginBottom: 0,
    minHeight: 420,
  },
  heroBadge: {
    alignSelf: 'flex-start',
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#FFFFFF',
    borderRadius: 999,
    paddingVertical: 8,
    paddingHorizontal: 12,
    marginBottom: 18,
  },
  heroBadgeText: {
    marginLeft: 6,
    color: BRAND.primaryDeep,
    fontSize: 12,
    fontWeight: '700',
  },
  welcomeTitle: {
    fontSize: 30,
    lineHeight: 36,
    fontWeight: '800',
    color: BRAND.primaryDeep,
    marginBottom: 12,
  },
  heroLead: {
    fontSize: 15,
    lineHeight: 24,
    color: BRAND.text,
    marginBottom: 22,
  },
  infoList: {
    marginTop: 4,
  },
  infoRow: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    marginBottom: 14,
  },
  infoDot: {
    width: 22,
    height: 22,
    borderRadius: 11,
    backgroundColor: BRAND.primary,
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: 10,
    marginTop: 1,
  },
  infoText: {
    flex: 1,
    color: BRAND.text,
    fontSize: 14,
    lineHeight: 21,
  },
  contentCard: {
    backgroundColor: BRAND.card,
    borderRadius: 28,
    padding: 22,
    borderWidth: 1,
    borderColor: '#ECECF3',
    shadowColor: '#0F172A',
    shadowOffset: { width: 0, height: 10 },
    shadowOpacity: 0.06,
    shadowRadius: 24,
    elevation: 4,
  },
  contentCardDesktop: {
    width: '62%',
  },
  sectionEyebrow: {
    color: BRAND.secondary,
    fontSize: 12,
    fontWeight: '800',
    letterSpacing: 1,
    textTransform: 'uppercase',
    marginBottom: 14,
  },
  welcomeText: {
    fontSize: 15,
    lineHeight: 26,
    marginBottom: 12,
    color: '#475467',
  },
  buttonGroup: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    marginTop: 12,
  },
  buttonGroupMobile: {
    flexDirection: 'column',
  },
  button: {
    minHeight: 56,
    paddingVertical: 14,
    paddingHorizontal: 16,
    borderRadius: 18,
    borderWidth: 1,
    marginBottom: 12,
    justifyContent: 'center',
    shadowColor: '#190B31',
    shadowOffset: { width: 0, height: 8 },
    shadowOpacity: 0.08,
    shadowRadius: 18,
    elevation: 3,
  },
  buttonContent: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },
  buttonIcon: {
    marginRight: 8,
  },
  buttonText: {
    fontSize: 14,
    fontWeight: '800',
    letterSpacing: 0.3,
  },
});

export default Welcome;
